<template>
  <div id="container">

    <el-container ref="backHomeContainer" class="back-home-container" style="border: 1px solid #EEE">
      <el-header ref="backHomeHeader" class="header" style="text-align: right; font-size: 12px">
        <div id="logo" class="left"></div>
        <div class="wrap-right">
          <!-- 订单提示icon -->
          <div v-if="routerList.includes('backOrderManage')" class="order-icon" @click="goList(1)">
            <el-tooltip class="item" content="新订单" effect="dark" placement="left">
              <div style="position: relative;">
                <i class="el-icon-tickets" style="font-size: 20px;cursor: pointer;"></i>
                <span v-if="$store.state.orderNum !== 0">
                  {{ $store.state.orderNum >= 100 ? '99+' : $store.state.orderNum }}
                </span>
              </div>
            </el-tooltip>
          </div>
          <!-- 发票提示icon -->
          <div v-if="routerList.includes('backInvoiceTitle')" class="order-icon" @click="goList(2)">
            <el-tooltip class="item" content="新发票" effect="dark" placement="left">
              <div style="position: relative;">
                <i class="el-icon-bell" style="font-size: 20px;cursor: pointer;"></i>
                <span v-if="$store.state.invoiceNum !== 0">
                  {{ $store.state.invoiceNum >= 100 ? '99+' : $store.state.invoiceNum }}
                </span>
              </div>
            </el-tooltip>
          </div>

          <el-button @click="toUniHome">统一后台首页</el-button>
          <span class="user-name">欢迎 {{ userInfo.userName }}</span>
          <el-dropdown style="margin-left: 10px;" trigger="click">
            <i class="el-icon-setting" style="margin-right: 15px"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="loginOut">退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container ref="backHomeContent" class="back-home-content">
        <el-aside style="background-color: rgb(238, 241, 246)" width="200px">
          <el-menu :default-active="defaultActive" :unique-opened="true" background-color="#EEF1F6">
            <el-submenu v-for="(item) in menuList" :key="item.id" :index="item.id + ''">
              <template slot="title">
                {{ item.privilegeName }}
              </template>
              <el-menu-item v-for="(item2) in item.childPrivilege" :key="item2.id" :index="item2.id + ''"
                            @click="clickNextMenu(item2.id + '', item2.page)">
                {{ item2.privilegeName }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-container>
          <template v-if="!isShow403">
            <router-view/>
          </template>
          <div v-else class="role-403">
            <div class="box">
              <div class="text-404">403</div>
              <div class="text">没有权限访问</div>

              <el-button class="re-register" type="primary" @click="loginOut">重新登录</el-button>
            </div>
          </div>
        </el-container>
      </el-container>

    </el-container>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :top="30 + 'vh'"
               :visible.sync="dialogAddVisible" title="警告" width="50%">
      您的IE浏览器版本过低，请将IE浏览器升级至最高版本！
    </el-dialog>
  </div>
</template>

<script>
// import logoImage from '@/assets/logo.png'
import utils from "@/utils/utils";

export default {
  name: 'backHome',
  data() {
    return {
      dialogAddVisible: false,
      defaultOpeneds: ['1'],
      defaultActive: '0',
      menuList: [],
      userInfo: [],
      routerList: [],
      isShow403: false,
    }
  },
  watch: {
    '$route'() {
      this.listenActiveRoute();
    }
  },
  created() {
    this.$store.dispatch('changeOrderNum')
    this.$store.dispatch('changeInvoiceNum')
  },
  mounted() {
    let browerVersion = this.utils.IEVersion();
    if (!(browerVersion == '0' || browerVersion == '11' || browerVersion == 'edge')) {
      this.dialogAddVisible = true;
    }
    // console.log(this.$refs.backHomeContent.$el.offsetHeight)
    let containerHeight = this.$refs.backHomeContainer.$el.offsetHeight;
    let headerHeight = this.$refs.backHomeHeader.$el.offsetHeight;
    // let contentHeight = this.$refs.backHomeContent.$el.offsetHeight;
    this.$refs.backHomeContent.$el.style.height = (containerHeight - headerHeight - 4) + 'px';

    let loading = this.$loading(this.utils.defaultLoadingOptions);
    this.$request.currentUser().then((res) => {
      // console.log(res)
      loading.close();
      if (res.status == 200) {
        let resData = res.data;
        this.userInfo.nickName = resData.nickname;
        this.userInfo.userName = resData.userName;
        this.userInfo.userpic = resData.userpic;
        this.userInfo.tel = resData.tel;
        this.$store.commit('changeUserid', resData.userInfo.userid)
        this.$store.commit('changeUserName', resData.userInfo.userName)
        this.$store.commit('changeTel', resData.tel); // 保存管理员用户名
        if (resData.privileges.length) {//后台管理员
          this.isShow403 = false
          this.menuList = resData.privileges;
          this.menuList.forEach(item => {
            if (item.childPrivilege.length !== 0) {
              item.childPrivilege.forEach(item2 => {
                this.routerList.push(item2.page)
              })
            }
          })
          // console.log('this.routerList', this.routerList)

          if (this.$route.name == 'backHome') {
            this.$router.push({
              name: resData.privileges[0].childPrivilege[0].page
            });
          } else {
            this.listenActiveRoute();
          }
        } else {
          this.isShow403 = true
          // alert('客户端')
        }
      } else {
        this.requestError(res.status, res.message)
      }

    }, (err) => {
      // console.log(err);
      loading.close();
      this.requestFail(err);
    })
    /*let defaultOpened = sessionStorage.getItem('defaultOpened');
    let defaultActive = sessionStorage.getItem('defaultActive');
    if(defaultOpened){
        this.defaultOpeneds = [defaultOpened];
    }
    if(defaultActive){
        this.defaultActive = defaultActive;
    }*/
    // console.log(defaultOpened)
  },
  components: {
    // Footer
  },
  methods: {
    // 前往统一登录首页
    toUniHome() {
      location.href = utils.getSsoUrl()
    },
    goList(type) {
      if (type === 1) {
        // 前往订单列表
        if (this.$route.path !== '/backHome/backOrderManage') {
          this.$router.push({
            path: '/backHome/backOrderManage',
          })
        }
      } else {
        // 前往发票列表
        if (this.$route.path !== '/backHome/backInvoiceTitle') {
          this.$router.push({
            path: '/backHome/backInvoiceTitle',
          })
        }
      }
    },
    listenActiveRoute() {
      let havePrivilege = false;
      this.menuList.forEach((item) => {
        item.childPrivilege.forEach((item2) => {
          if (this.$route.path.search(item2.page) !== -1) {
            havePrivilege = true;
            this.defaultOpeneds = [item.icon];
            this.defaultActive = item2.id + '';
          }
        });
      });
      if (!havePrivilege) {
        utils.logout()
      }
    },
    clickNextMenu(defaultOpened, router) {
      this.defaultActive = defaultOpened
      if (this.$route.name != router) {
        // sessionStorage.setItem('defaultOpened',defaultOpened);
        // sessionStorage.setItem('defaultActive',defaultActive);
        this.$router.push('/backHome/' + router)
      }
    },
    loginOut() {
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      utils.logout()
    }
  }
}
</script>
<style lang="less" scoped>
a {
  text-decoration: none;
}

.el-container {

  .role-403 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
    color: #409EFF;

    .box {
      margin-top: -100px;

      .text-404 {
        font-size: 150px;
      }

      .text {
        font-size: 50px;
      }

      .re-register {
        width: 120px;
        height: 45px;
        margin-top: 20px;
        font-size: 18px;
      }
    }

  }

  .height();

  .el-input {
    .width(auto);
  }

  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #409EFF;
    .color(#FFF);

    //.lh(60px);
    #logo {
      .size(114px);
      .bg("@{img-base-url}public_logo.png");
      margin-left: 20px;
      scale: 0;
    }

    .header-title {
      font-size: 28px;
    }

    .user-name {
      padding-left: 10px;
      font-size: 16px;
    }

    .wrap-right {
      .order-icon {
        display: inline-block;
        position: relative;
        margin-right: 15px;

        span {
          position: absolute;
          right: -50%;
          top: -50%;
          display: inline-block;
          background-color: red;
          padding: 0 2px;
          border-radius: 5px;
          height: 12px;
          line-height: 12px !important;
        }
      }

      .item {
        //height: 30px;
        //width: 40px;
        margin-top: 10px;
        margin-right: 10px;
      }
    }

    .el-dropdown {
      .color(#FFF);
      .fz(20px);

      .el-dropdown-selfdefine {
        cursor: pointer;
      }
    }
  }

  .el-aside {
    .color(#333);

    .el-menu {
      text-align: left;

      .el-submenu {

        .el-menu-item {
          padding-left: 60px !important;
        }
      }
    }
  }

  .el-main {
    .height();
    /*overflow-y: scroll;*/
  }
}
</style>